import React from 'react';
import { XMarkIcon, UserIcon, PencilIcon, TrashIcon, LinkSlashIcon } from '@heroicons/react/24/outline';
import { getPhotoUrl } from '../../../utils/residentFunctions';
import { getResidentInitials } from '../../../utils/photoUtils';

const FamilyMemberViewModal = ({
  show,
  onClose,
  familyMember,
  onEdit,
  onDelete,
  onDetach
}) => {
  if (!show || !familyMember) return null;

  const formatDate = (dateString) => {
    if (!dateString) return 'Not specified';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-md w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b">
          <h3 className="text-lg font-semibold text-gray-900">Family Member Details</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Profile Section */}
          <div className="flex items-center mb-6">
            <div className="h-16 w-16 bg-gray-200 rounded-full flex items-center justify-center overflow-hidden">
              {getPhotoUrl(familyMember) ? (
                <img
                  src={getPhotoUrl(familyMember)}
                  alt={`${familyMember.first_name} ${familyMember.last_name}`}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentNode.querySelector('.fallback-avatar').style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className={`fallback-avatar w-full h-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center text-white font-bold text-lg ${getPhotoUrl(familyMember) ? 'hidden' : 'flex'}`}
              >
                {getResidentInitials(familyMember)}
              </div>
            </div>
            <div className="ml-4">
              <h4 className="text-xl font-semibold text-gray-900">{familyMember.name}</h4>
              <p className="text-gray-600">{familyMember.relationship}</p>
            </div>
          </div>

          {/* Details Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Age</label>
              <p className="text-gray-900">{familyMember.age || 'Not specified'}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Birthdate</label>
              <p className="text-gray-900">{formatDate(familyMember.birthdate)}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
              <p className="text-gray-900">{familyMember.gender || 'Not specified'}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Occupation</label>
              <p className="text-gray-900">{familyMember.occupation || 'Not specified'}</p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                familyMember.status === 'active'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-800'
              }`}>
                {familyMember.status || 'Active'}
              </span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="border-t px-6 py-4 flex justify-end space-x-3">
          <button
            onClick={() => onEdit(familyMember)}
            className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <PencilIcon className="h-4 w-4 mr-2" />
            Edit
          </button>

          <button
            onClick={() => onDelete(familyMember)}
            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <LinkSlashIcon className="h-4 w-4 mr-2" />
            Detach
          </button>

          {/* <button
            onClick={() => onDelete(familyMember)}
            className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
          >
            <TrashIcon className="h-4 w-4 mr-2" />
            Delete
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default FamilyMemberViewModal;
